module.exports = __webpack_public_path__ + "static/media/emoji-green.c6f11f5d.svg";